<template>
  <div class="pb-6 px-6 pt-0" style="width: 100%">
    <CreateExamForm :state="dialog" @closeDialog="close" @refresh="getExams" />
    <div class="py-6 d-flex" style="width: 100%">
      <div class="component-title">Danh sách kỳ thi</div>
    </div>
    <div class="d-flex justify-end align-center mb-6">
      <v-btn color="primary" class="elevation-0 ml-6" dark @click="openCreate">
        <v-icon left>mdi-package-variant-closed</v-icon>Thêm kỳ thi</v-btn
      >
    </div>

    <v-card class="elevation-1">
      <ExamTable :exams="exams" />
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ExamTable from '@/modules/exam/ExamTable.vue'
import CreateExamForm from '@/modules/exam/CreateExamForm.vue'

export default {
  components: {
    ExamTable,
    CreateExamForm
  },
  data() {
    return {
      dialog: false,
      exams: []
    }
  },
  async created() {
    this.$loading.active = true
    await this.getExams({})
    this.$loading.active = false
  },
  methods: {
    ...mapActions('exam', ['fetchExams']),
    async getExams(query) {
      this.$loading.active = true
      const exams = await this.fetchExams({ ...query })
      this.exams = exams
      this.$loading.active = false
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.component-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #0d47a1;
}
</style>
